import { useNavigate } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import { UserForm } from '@/components/forms/UserForm'
import { usersApi } from '@/api/users'
import type { CreateUserInput } from '@/types/user'
import { getApiErrorMessage } from '@/utils/error'

export const UserCreate = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const createMutation = useMutation({
    mutationFn: usersApi.createUser,
    onSuccess: (data) => {
      message.success('User created successfully')
      queryClient.invalidateQueries({ queryKey: ['users'] })
      navigate(`/users/${data.data.id}`)
    },
    onError: (error: unknown) => {
      message.error(getApiErrorMessage(error, 'Failed to create user'))
    },
  })

  const handleSubmit = (values: CreateUserInput) => {
    createMutation.mutate(values)
  }

  const handleCancel = () => {
    navigate('/users')
  }

  return (
    <div>
      <h1>Create New User</h1>
      <UserForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={createMutation.isPending}
      />
    </div>
  )
}
